import { paymentStatementApi } from './base';

export interface APIKeyUsageStats {
	total_requests: number;
	requests_today: number;
	requests_this_month: number;
}

export interface APIKey {
	id: string;
	enterprise_id?: string;
	tenant_id?: string;
	key_prefix: string;
	key_name: string;
	full_key?: string; // Only present on creation
	is_active: boolean;
	expires_at: string | null;
	last_used_at: string | null;
	created_at: string;
	rate_limit: number;
	usage?: APIKeyUsageStats;
}

export interface APIKeyListResponse {
	api_keys: APIKey[];
}

export interface CreateAPIKeyRequest {
	key_name: string;
	enterprise_id: string;
	expires_in_days?: number;
	rate_limit?: number;
}

export interface CreateAPIKeyResponse {
	success: boolean;
	message: string;
	api_key: APIKey;
}

export interface RevealAPIKeyResponse {
	success: boolean;
	full_key: string;
}

export const apiKeysApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		listAPIKeys: builder.query<
			APIKeyListResponse,
			{ enterpriseId?: string } | void
		>({
			query: (params) => ({
				url: '/statement/api-keys',
				method: 'GET',
				params: params?.enterpriseId
					? { enterprise_id: params.enterpriseId }
					: {},
			}),
			providesTags: ['APIKeys'],
		}),
		createAPIKey: builder.mutation<CreateAPIKeyResponse, CreateAPIKeyRequest>({
			query: (data) => ({
				url: '/statement/api-keys',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['APIKeys'],
		}),
		revokeAPIKey: builder.mutation<
			void,
			{ keyId: string; enterpriseId?: string }
		>({
			query: ({ keyId, enterpriseId }) => ({
				url: `/statement/api-keys/${keyId}`,
				method: 'DELETE',
				params: enterpriseId ? { enterprise_id: enterpriseId } : {},
			}),
			invalidatesTags: ['APIKeys'],
		}),
		revealAPIKey: builder.mutation<
			RevealAPIKeyResponse,
			{ keyId: string; enterpriseId?: string }
		>({
			query: ({ keyId, enterpriseId }) => ({
				url: `/statement/api-keys/${keyId}/reveal`,
				method: 'POST',
				params: enterpriseId ? { enterprise_id: enterpriseId } : {},
			}),
		}),
	}),
});

export const {
	useListAPIKeysQuery,
	useCreateAPIKeyMutation,
	useRevokeAPIKeyMutation,
	useRevealAPIKeyMutation,
} = apiKeysApi;
